(() => {
	const ignoredVariantIds = [];

	document.addEventListener('DOMContentLoaded', () => {
		document.addEventListener('rebuy.addBundleToCart', function(event) {
			const {
				widget: {
					data: {
						products
					}
				}
			} = event.detail;

			const removedVariants = {};

			if (!products || products.length === 0) return;

			products.forEach(product => {
				const variantId = product.selected_variant_id.toString();
				const isInCart = getCartItems()
					.find(item => item?.variant_id.toString() === variantId);

				if (!isInCart) {
					return;
				}

				const inCartQuantity = isNaN(removedVariants[isInCart.key]) ? isInCart.quantity : removedVariants[isInCart.key];

				// Remove the variant from the cart, since it's being added via bundle
				if (inCartQuantity > 0) {
					Rebuy.Cart.updateItem({
						updates: {
							[isInCart.key]: (removedVariants[isInCart.key] || isInCart.quantity) - 1,
						}
					});

					removedVariants[isInCart.key] = inCartQuantity - 1;
				}
			})
		});

		document.addEventListener('rebuy.addProductToBundle', function(event){
			const {
				widget: {
					data: {
						products
					},
					template
				}
			} = event.detail;

			if (!products || products.length === 0 || !template) return;

			if (products.length >= 4 &&  window.getComputedStyle(template, null).display !== 'none') {
				closeBundleListing();
				document.querySelector('.rebuy-cart__flyout [data-rebuy-cart-scroll-area]').classList.add('has-bundle');

				const bundleATCButton = template.querySelector('.rebuy-bundle-builder__cta-container .rebuy-button');

				if (bundleATCButton) {
					bundleATCButton.click();
					bundleATCButton.dispatchEvent(new MouseEvent('click', { bubbles: true }) );
				}
			}
		});

		document.addEventListener('rebuy.removeProductFromBundle', function(event){
			const {
				product: {
					selected_variant_id
				}
			} = event.detail;

			if (!selected_variant_id || ignoredVariantIds.includes(selected_variant_id)) return;

			// ignoredVariantIds.push(selected_variant_id.toString());
		});

		document.addEventListener('rebuy:cart.change', () => {
			checkIfCartEmpty();
			checkIfBundleInCart();
		});

		document.addEventListener('rebuy:smartcart.ready', (event) => {
			const rebuyBundleBuilders = document.querySelectorAll('.rebuy-bundle-builder--container');
			const rebuySmartCartTarget = document.querySelector('.rebuy-cart__flyout [data-rebuy-cart-scroll-area]');
			const rebuySmartCartHeader = document.querySelector('.rebuy-cart__flyout [data-rebuy-cart-anchor="header"]');

			if (!rebuySmartCartTarget || !rebuyBundleBuilders || rebuyBundleBuilders.length <= 0 || !rebuySmartCartHeader) {
				return;
			}

			rebuyBundleBuilders.forEach(rebuyBundleBuilder => {
				rebuySmartCartTarget.prepend(rebuyBundleBuilder);
			})

			rebuySmartCartTarget.prepend(rebuySmartCartHeader);

			let isRunning = false;

			checkIfBundleInCart();
			checkIfCartEmpty();
			closeBundleListing();

			// Cart watch loop
			setInterval(() => {
				if (isRunning) return;

				isRunning = true;

				updateDynamicTitles();
				checkBundleProductImageQuality();
				updateBundleCompareAtPrice();
				syncBuildersWithCart();
				renderBundleFlavorImages();
				checkBundleSubscriptionInCart();
				checkZeroedItems();
				syncDeliveryFrequency();
				checkIfBundleListingOpen();

				isRunning = false;
			}, 100)
		});

		document.addEventListener('rebuy.ready', (event) => {
			const bundleContainer = event.detail.widget.template;

			if (!bundleContainer) {
				return;
			}

			bundleContainer.addEventListener('click', (event) => {
				if (event.target.closest('.rebuy-bundle-builder__product-sign-holder')) {
					toggleBundleListing();
				}
			})
		})
	})

	function toggleBundleListing() {
		const productSteps = document.querySelectorAll(`.rebuy-bundle-builder--container .rebuy-bundle-builder__step-container`);

		if (!productSteps || productSteps.length === 0) return;

		productSteps.forEach(step => {
			if (step.classList.contains('rebuy-bundle-builder__step-container--not-active')) {
				step.classList.remove('rebuy-bundle-builder__step-container--not-active');
				step.classList.add('rebuy-bundle-builder__step-container--active');
			}

			else if (step.classList.contains('rebuy-bundle-builder__step-container--active')) {
				step.classList.remove('rebuy-bundle-builder__step-container--active');
				step.classList.add('rebuy-bundle-builder__step-container--not-active');
			}
		})
	}

	function closeBundleListing() {
		const productSteps = document.querySelectorAll(`.rebuy-bundle-builder--container .rebuy-bundle-builder__step-container`);

		if (!productSteps || productSteps.length === 0) return;

		productSteps.forEach(step => {
			if (step.classList.contains('rebuy-bundle-builder__step-container--active')) {
				step.classList.remove('rebuy-bundle-builder__step-container--active');
				step.classList.add('rebuy-bundle-builder__step-container--not-active');
			}
		})
	}

	function openBundleListing() {
		const productSteps = document.querySelectorAll(`.rebuy-bundle-builder--container .rebuy-bundle-builder__step-container`);

		if (!productSteps || productSteps.length === 0) return;

		productSteps.forEach(step => {
			if (step.classList.contains('rebuy-bundle-builder__step-container--not-active')) {
				step.classList.remove('rebuy-bundle-builder__step-container--not-active');
				step.classList.add('rebuy-bundle-builder__step-container--active');
			}
		})
	}

	function updateDynamicTitles() {
		const rebuyBundleBuilders = document.querySelectorAll('.rebuy-bundle-builder--container');

		rebuyBundleBuilders.forEach(builder => {
			const dynamicTitle = builder.querySelector('.rebuy-bundle-builder__group-container-header-title');

			if (!dynamicTitle) return;

			const blankProductHolder = builder.querySelectorAll('.rebuy-bundle-builder__product-holder-template');
			const count = blankProductHolder ? blankProductHolder.length - 1 : 3;
			const dynamicTitleText = count <= 0 ?
				`Add your Free Bonus pouch!` :
				`Add <span class="count--text">${count}</span> more pouch${count > 1 ? 'es' : ''} to get your Free Bonus pouch.`

			if (dynamicTitle.innerHTML === dynamicTitleText)
				return;

			dynamicTitle.innerHTML = dynamicTitleText;
		})
	}

	function checkBundleProductImageQuality() {
		const rebuyBundleBuilders = document.querySelectorAll('.rebuy-bundle-builder--container');

		rebuyBundleBuilders.forEach(builder => {
			const productImages = builder.querySelectorAll('.rebuy-bundle-builder__product-holder-media img');

			productImages.forEach(img => {
				const src = img.getAttribute('src');

				if (!src.includes('_80x80')) return;

				img.setAttribute('src', src.replace('_80x80', ''));
			});
		})
	}

	function updateBundleCompareAtPrice() {
		const cartProductElements = document.querySelectorAll('.rebuy-cart__flyout .rebuy-cart__flyout-item.product-bundle');

		cartProductElements.forEach(cartProduct => {
			const existingCompareAt = cartProduct.querySelector('.rebuy-cart__flyout-item-price .compare-at');

			if (existingCompareAt) return;

			const priceElement = cartProduct.querySelector('.rebuy-cart__flyout-item-price .rebuy-money');

			if (!priceElement) return;

			const price = parseFloat(priceElement.lastElementChild.innerText.replace('$', ''));
			const compareAtPrice = price / .75;

			const compareAtElment = document.createElement('div');
			compareAtElment.classList.add('rebuy-money', 'compare-at');
			compareAtElment.innerHTML = `
				<span class="sr-only">Original price</span>
				<span class="rebuy-money-symbol">$${compareAtPrice}</span>
			`;

			priceElement.parentNode.insertBefore(compareAtElment, priceElement.nextSibling);
			priceElement.classList.add('sale');
		});
	}

	function syncBuildersWithCart() {
		const bundleListProducts = document.querySelectorAll('.rebuy-bundle-builder .rebuy-bundle-builder__step-body .rebuy-product-block');
		const variantsInCart = getCartItems()
			.map(item => {
				return {
					id: item.variant_id.toString(),
					quantity: item.quantity
				}
			});

		if (!bundleListProducts || bundleListProducts.length === 0) {
			return;
		}

		if (!variantsInCart || variantsInCart.length === 0) {
			return;
		}

		bundleListProducts.forEach((product) => {
			const anchor = product.querySelector('a');
			const trigger = product.querySelector('.rebuy-button');
			const addButton = product.querySelector('.rebuy-bundle-builder__item-quantity-widget-button:last-child');
			const quantityLabel = product.querySelector('.rebuy-bundle-builder__item-quantity-widget-label');

			if (!trigger && !addButton) {
				return;
			}

			if (!anchor || !anchor.href) {
				return;
			}

			const url = new URL(anchor.href);
			const variantParam = url.searchParams.get('variant');
			const isInCart = variantsInCart.find(v => v.id === variantParam);

			if (!ignoredVariantIds.includes(variantParam) && isInCart) {
				// Click the trigger, then get the plus quantity button and click that as many times as quantity in cart
				if (trigger) {
					trigger.click();
				}

				else if (isInCart.quantity > parseInt(quantityLabel.innerText)) {
					addButton.click();
				}
			}
		});
	}

	function renderBundleFlavorImages() {
		const bundleListProductInfo = document.querySelectorAll('.rebuy-bundle-builder .rebuy-bundle-builder__step-product .rebuy-product-info');

		if (bundleListProductInfo && bundleListProductInfo.length > 0) {
			bundleListProductInfo.forEach(info => {
				const existingFlavorContainer = info.querySelector('.flavor-image-container');

				if (existingFlavorContainer) return;

				const title = info.querySelector('.rebuy-variant-title');
				const flavors = title.innerText.split(' / ', 2);

				// if (flavors[0] === "Longevity Coffee") {
				// 	const infoParent = info.closest(".rebuy-product-block");
				//
				// 	infoParent.remove();
				// 	return;
				// }

				const flavorImageContainer = document.createElement('div');
				flavorImageContainer.classList.add('flavor-image-container');
				info.insertBefore(flavorImageContainer, info.firstChild);

				flavors.forEach(flavor => {
					const flavorImage = window.metaOptionIcons?.icons?.[flavor.trim()];

					if (flavorImage) {
						const img = document.createElement('img');
						img.src = flavorImage;
						img.alt = flavor;

						flavorImageContainer.appendChild(img);
					}
				})
			})
		}
	}

	function checkBundleSubscriptionInCart() {
		const cartItems = getCartItems();
		const hasBundleSubscription = cartItems.some(item => item.product?.subscription);
		const rebuySmartCartTarget = document.querySelector('.rebuy-cart__flyout [data-rebuy-cart-scroll-area]');

		rebuySmartCartTarget?.classList.toggle('has-subscription', hasBundleSubscription);
	}

	function checkZeroedItems() {
		const quantityWidget = document.querySelectorAll('.rebuy-bundle-builder--container .rebuy-bundle-builder__item-quantity-widget');


		quantityWidget.forEach(widget => {
			const quantityInput = widget.querySelector('.rebuy-bundle-builder__item-quantity-widget-label');

			if (quantityInput && parseInt(quantityInput.innerText) === 0) {
				const addButton = widget.querySelector('.rebuy-bundle-builder__item-quantity-widget-button:last-child');

				if (addButton) {
					addButton.click();
				}
			}
		})

	}

	function checkIfBundleInCart() {
		const bundleCartItems = getBundleCartItems();
		const rebuySmartCartTarget = document.querySelector('.rebuy-cart__flyout [data-rebuy-cart-scroll-area]');

		if (!rebuySmartCartTarget)
			return;

		rebuySmartCartTarget.classList.toggle('has-bundle', bundleCartItems.length > 0);

		if (bundleCartItems.length > 0) {
			clearBundle();
		}

		return bundleCartItems.length > 0;
	}

	function checkIfCartEmpty() {
		const cartItems = getCartItems();
		const rebuySmartCartTarget = document.querySelector('.rebuy-cart__flyout [data-rebuy-cart-scroll-area]');

		if (!rebuySmartCartTarget)
			return;

		rebuySmartCartTarget.classList.toggle('is-empty', cartItems?.length === 0);

		if (cartItems?.length === 0) {
			clearBundle();
		}
	}

	function checkIfBundleListingOpen() {
		const rebuySmartCartTarget = document.querySelector('.rebuy-cart__flyout [data-rebuy-cart-scroll-area]');
		const rebuyBundleBuilder = document.querySelector('.rebuy-bundle-builder__step-container');

		if (!rebuySmartCartTarget || !rebuyBundleBuilder)
			return;

		rebuySmartCartTarget.classList.toggle('listing-open', rebuyBundleBuilder.classList.contains('rebuy-bundle-builder__step-container--active'));
	}

	function clearBundle() {
		const deleteButtons = document.querySelectorAll('.rebuy-bundle-builder__product-holder-info-delete');

		deleteButtons.forEach(() => {
			const deleteButton = document.querySelector('.rebuy-bundle-builder__product-holder-info-delete');

			if (!deleteButton)
				return;

			deleteButton.click();
		})
	}

	function getCartItems() {
		return Rebuy.Cart.cart.items
			.filter(item =>
				item?.properties?._attribution !== 'Rebuy Bundle Builder Subscription' &&
				!item?.selling_plan_allocation &&
				item?.handle !== 'bundle'
			);
	}

	function getBundleCartItems() {
		return Rebuy.Cart.cart.items
			.filter(item =>
				item?.properties?._attribution === 'Rebuy Bundle Builder Subscription' ||
				item?.handle === 'bundle'
			);
	}

	function syncDeliveryFrequency() {
		const existingDeliveryFreq = document.querySelector('[data-rebuy-component="cart-items"] .rebuy-cart__flyout-item-subscription select');
		const bundleDeliveryFreq = document.querySelector('#rebuy-bundle-builder-subscription-interval');

		if (!existingDeliveryFreq || !existingDeliveryFreq.value || !bundleDeliveryFreq || !bundleDeliveryFreq.value || existingDeliveryFreq.value === bundleDeliveryFreq.value) {
			return;
		}

		bundleDeliveryFreq.value = existingDeliveryFreq.value;
	}
})();
